import { render, staticRenderFns } from "./employee-account.vue?vue&type=template&id=572d8a08&"
import script from "./employee-account.component.ts?vue&type=script&lang=ts&"
export * from "./employee-account.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports